import { type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export type ProgressGoalIndicatorProps = HTMLAttributes<HTMLDivElement> & {
  orientation?: 'above' | 'below';
};

const ProgressGoalIndicator = ({
  className,
  orientation = 'above',
  ...props
}: ProgressGoalIndicatorProps) => {
  return (
    <div
      className={cn('relative h-full text-green-400', className)}
      data-slot="progress-goal-indicator"
      {...props}
    >
      <div
        className={cn(
          'absolute right-0 border-l-2 border-dashed',
          orientation === 'above' && '-top-2 bottom-0',
          orientation === 'below' && 'top-0 -bottom-2',
        )}
        style={{ borderLeftColor: 'currentColor' }}
      />
      <div
        className={cn(
          'absolute -right-0.5 size-1.5 rounded-full',
          orientation === 'above' && '-top-4',
          orientation === 'below' && '-bottom-4',
        )}
        style={{ backgroundColor: 'currentColor' }}
      />
    </div>
  );
};

export default ProgressGoalIndicator;
